import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import api, { timeAgo } from "@/lib/api";

const catLabel = (a: any) => (a.categories && a.categories[0] ? a.categories[0].replace(/-/g, " ") : null);

export const MostApplaudedRail = () => {
  const { data } = useQuery({
    queryKey: ["most-applauded"],
    queryFn: async () => (await api.get("/most-applauded")).data,
    staleTime: 2 * 60 * 1000,
  });
  const items = data?.items || [];
  if (items.length < 3) return null;

  return (
    <section className="max-w-7xl mx-auto px-4 sm:px-6 py-10" data-testid="most-applauded-rail">
      <div className="flex flex-wrap items-baseline justify-between gap-2 mb-6">
        <div>
          <p className="font-mono text-[11px] uppercase tracking-[0.28em] text-[#00E5FF] mb-1.5">Reader signal</p>
          <h2 className="font-heading font-black text-white text-lg md:text-2xl">
            Most applauded {data.window === "7d" ? "this week" : "by readers"}
          </h2>
        </div>
        <span className="font-mono text-[10px] uppercase tracking-widest text-gray-600">
          Ranked by real reader applause
        </span>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {items.slice(0, 6).map((a: any, i: number) => (
          <Link key={a.slug} to={`/article/${a.slug}`} data-testid={`applauded-card-${a.slug}`}
            className="group relative overflow-hidden rounded-xl border border-white/[0.08] bg-[#0b0b0f] px-5 py-4 transition-colors duration-200 hover:border-[#7C3AED]/50">
            <div className="flex items-start gap-4">
              <span className="font-heading font-black text-2xl leading-none text-white/15 group-hover:text-[#7C3AED]/60 transition-colors" aria-hidden>
                {String(i + 1).padStart(2, "0")}
              </span>
              <div className="min-w-0 flex-1">
                <p className="text-white text-sm font-semibold leading-snug line-clamp-2 group-hover:text-[#00E5FF] transition-colors">
                  {a.title}
                </p>
                <p className="mt-2 flex items-center gap-2 font-mono text-[10px] uppercase tracking-wide text-gray-500">
                  {catLabel(a) && <span className="text-gray-400">{catLabel(a)}</span>}
                  {a.published_at && <span>{timeAgo(a.published_at)}</span>}
                </p>
              </div>
              <span data-testid={`applauded-count-${a.slug}`}
                className="shrink-0 inline-flex items-center gap-1 rounded-full border border-[#7C3AED]/35 bg-[#7C3AED]/12 px-2.5 py-1 font-mono text-[11px] font-bold text-[#c4a6ff]">
                👏 {(a.claps_window || 0).toLocaleString()}
              </span>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
};
